/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMilFormEmbedViewProps } from './mil-form-embed';

export default (props: IMilFormEmbedViewProps) => {
    React.useEffect(() => {
        document.querySelector('head')?.appendChild(props.script);
    }, []);

    return (
        <div className='row'>
            <div className='mil-form-embed' id={props.config.divId}></div>
        </div>
    );
};
